import { MedicalTourismApplyFormData, PostJandiPayload } from '../types';

// 관심 서비스 한국어 텍스트 변환
const getServiceText = (service: 'all' | 'payment' | 'reservation'): string => {
  switch (service) {
    case 'all':
      return '전체';
    case 'payment':
      return '간편 결제 솔루션';
    case 'reservation':
      return '외국인 전용 예약 솔루션';
    default:
      return '';
  }
};

// Jandi 웹훅 메시지 템플릿 생성
const createJandiMessage = (
  formData: MedicalTourismApplyFormData,
): PostJandiPayload => {
  const serviceText = getServiceText(formData.selectedService);

  const body = `
**관심 서비스**
${serviceText}

**병원 정보**
• 병원명: ${formData.hospitalName}

**신청인 정보**
• 성함: ${formData.applicantName}
• 이메일: ${formData.email}
• 휴대폰번호: ${formData.phone}
• 직책: ${formData.position}

---
신청 시간: ${new Date().toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' })}
    `.trim();

  return {
    title: '🏥 외국인 환자 유치 서비스 신청',
    description: `${formData.hospitalName} - ${formData.applicantName} (${formData.position})`,
    body,
  };
};

export { getServiceText, createJandiMessage };
